import React, { useState, useEffect, useContext} from 'react';
import Card from '../../../components/card.component';
import {
  Col,
  Row,
} from 'react-bootstrap';
import table from '../reportes.table';
import DataTable from 'react-data-table-component';
import sucursalFunction from '../../sucursales/sucursal.functions';
import moment from 'moment';
import notification from '../../../components/notification.component';
import reportesFunctions from '../reportes.functions';
import PrinterDiario from '../imprimir/diario.printer';
import { ConfigContext } from '../../../context/config.context';
import utils from '../../../utils/utils.functions';
import { DateRangePicker } from 'rsuite';
import UsuariosSelect from '../../../components/usuarios.component';
import { ConfigContextUtils } from '../../../context/contextUtils.context';

const DesgloseReport = () => {

  const { config } = useContext(ConfigContext);
  const { setPreloader } = useContext(ConfigContextUtils);
  const rpValuesOne = {
    init:  moment(new Date()).format('YYYY-MM-DD'),
    end:  moment(new Date()).format('YYYY-MM-DD'),
    sucursales: [],
  }

  const initCalendar = [new Date(), new Date()];

  const [sucursales, setSucursales] = useState([]);
  const [reporteOne, setRerporteOne] = useState(rpValuesOne);
  const [dataRpOne, setDataRpOne] = useState(null);
  const [toggleOne, setToggleOne] = useState(false);
  const [pagos, setPagosCalculate] = useState({
    puntoVentas: 0,
    efectivo: 0,
    transferencia: 0,
  });
  const [total, setTotal] = useState(0);
  const [dataOriginal, setOriginalValue] = useState(initCalendar);
  const [user, setUser] = useState({ id: 'null', username: 'Todos' });

  useEffect(() => {
    listarSucursales();
  },[]);

  useEffect(() => {
    let totalSum = (pagos.puntoVentas + pagos.efectivo + pagos.transferencia);
    setTotal(totalSum);
  },[pagos]);
  
  useEffect(() => {
      if (dataRpOne) {
        if (dataRpOne.guiasRespuesta.length) {

          let puntoVenta = 0;
          let efectivo = 0;
          let transferencia = 0;

          dataRpOne.guiasRespuesta.forEach((x) => {
            if (!x.anulado) {
              x.pagos_guia.forEach(e => {
                if (e.tipo_pago.description === 'Punto de venta') {
                  puntoVenta += parseInt(e.monto_pago);
                } else if (e.tipo_pago.description === 'Transferencia') {
                  transferencia += parseInt(e.monto_pago);
                } else if (e.tipo_pago.description === 'Efectivo') {
                  efectivo += parseInt(e.monto_pago);
                }
              })
            }
          });

          setPagosCalculate({
            puntoVentas: puntoVenta,
            efectivo: efectivo,
            transferencia: transferencia,
          });
          }
        } 
  },[dataRpOne]);

  const resetDate = () => {
    setRerporteOne(rpValuesOne);
    setOriginalValue(initCalendar);
  }

  const resetReportOne = () => {
    setRerporteOne(rpValuesOne);
    setToggleOne(!toggleOne);
    setDataRpOne(null);
    setOriginalValue(initCalendar);
  }

  const listarSucursales = () => {
    sucursalFunction.listado().then((response) => {
      setSucursales(response.data);
    })
  }

  const sucursalSelected = (rows) => {
    setRerporteOne({
      ...reporteOne,
      sucursales: rows.selectedRows,
    });
    setDataRpOne(null);
  }

  const setValueRpOne = (value) => {
    setRerporteOne({
      ...reporteOne,
      init: moment(value[0]).format('YYYY-MM-DD'),
      end: moment(value[1]).format('YYYY-MM-DD'),
    });

    setOriginalValue(value);
  }

  const generarReporteOne = () => {
    if (reporteOne.sucursales.length && reporteOne.init && reporteOne.end) {
      setPreloader(true);
      const ids = reporteOne.sucursales.map((e) => e.id);
      reportesFunctions.diario({ sucursales: ids, init: reporteOne.init, end: reporteOne.end, user: user.id }).then((response) => {
        setDataRpOne(response.results);
        setPreloader(false);
      })
    } else {
      notification.warning('Debe seleccionar al menos una sucursal y rango de fechas');
    }
  }

  const badgeEstado = (guia) => {
    if (guia.guia_finalizada) {
      return <span className="badge badge-success">ENTREGADO</span>
    }
    if (guia.anulado) {
      return <span className="badge badge-danger">ANULADO</span>
    }
    if (guia.guia_pendiente) {
      return <span className="badge badge-primary">RESERVADA</span>  
    }

    return <span className="badge badge-warning">TRANSITO</span>  
  }

  const colummns = [
    {
      name: 'Registrado',
      selector: 'createdAt',
      sortable: true,
      width: '10%',
      wrap: true,
      cell: row => (
        moment(row.createdAt).format('DD/MM/YYYY')
      )
    },
    {
       name: 'Guia',
       selector: 'guia_paquete',
       sortable: true,
       cell: (row) => (
        <div>{config.prefijo_correlativo_guia}-{row.guia_paquete}</div>
       )
     },
     {
      name: 'Cliente',
      sortable: true,
      cell: row => {
        return <div className="d-flex flex-column">
          <div style={{ fontSize: 11 }}>{row.cliente.rut}</div>
          <div style={{ fontSize: 12 }}>{row.cliente.name}</div>
          <div style={{ fontSize: 11 }}>{row.cliente.phone}</div>
        </div>
      }
    },
     {
       name: 'Estado',
       sortable: true,
       cell: row => {
         return badgeEstado(row)
       }
     },
     {
       name: 'Tipo',
       selector: row => row.master_guia.rel_tipos.description,
       sortable: true,
     },
     {
       name: 'Referencia',
       cell: row => {
         return row.guia_pendiente ? '--' : row.pagos_guia.map(e => (
            e.referencia
         ))
       }
     },
     {
      name: 'Monto pago',
      selector: 'monto_pago',
      sortable: true,
      cell: row => {
        const signo = row.anulado ? '-' : '+';
        return row.guia_pendiente ? '--' : <div style={{ color: row.anulado ? 'red' : 'black' }}>{signo}{utils.formatMoney(row.monto_pago)}</div>
      }
     },
     {
      name: 'Gestor',
      selector: row => row.gestor.username,
      sortable: true,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: '72px', // override the row height
      }
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };
  
  const estadoactual = (item) => {

    let statecurrent = { text: 'Transito', color: 'FFFFC107' };
    if (item.guia_finalizada) {
      statecurrent = { text: 'Entregado', color: 'FF28A745'};
    }
    if (item.anulado) {
      statecurrent = { text: 'Anulado', color: 'FFDC3545'};
    }
    if (item.guia_pendiente) {
      statecurrent = { text: 'Reserva', color: 'FF007BFF'}
    }

    return statecurrent;
 }

  const parsedataexcelformat = () => {

    const values = dataRpOne.guiasRespuesta;
    const dates = {
       start: moment(reporteOne.init).format('DD/MM/YYYY'),
       end: moment(reporteOne.end).format('DD/MM/YYYY'),
    }

    const dataexcel = values.map((item) => {
       return {
          date: moment(item.createdAt).format('DD/MM/YYYY'),
          guide: `${config.prefijo_correlativo_guia}-${item.guia_paquete}`,
          rut: item.cliente.rut,
          client_name: item.cliente.name.toUpperCase(),
          type: item.master_guia.rel_tipos.description,
          amount: item.anulado ? -Math.abs(item.monto_pago) : Math.abs(item.monto_pago),
          creator_guide: item.gestor.username,
          status: estadoactual(item),
          master: item.master_guia.description,
          sucursal: item.sucursal.description,
       }
    });

    
    const payload = {
      dates,
      dataexcel,
      pagos: {
        efectivo: pagos.efectivo,
        punto: pagos.puntoVentas,
        transferencia: pagos.transferencia,
      }
    }

    reportesFunctions.excelSoldReport(payload);
  }

  const userselectedfilter = (value) => {
    setDataRpOne(null);
    setUser(value);
  }

  const valuesPayments = () => {
    return <Row>
      <Col className="d-flex justify-content-between">
          <div>
              <small>Efectivo</small>
              <div className="monto-text">{utils.formatMoney(pagos.efectivo)}</div>
          </div>
          <div>
              <small>Punto de venta</small>
              <div className="monto-text">{utils.formatMoney(pagos.puntoVentas)}</div>
          </div>
          <div>
              <small>Transferencias</small>
              <div className="monto-text">{utils.formatMoney(pagos.transferencia)}</div>
          </div>
          <div>
              <small>Total ventas</small>
              <div className="monto-text amount-good">{utils.formatMoney(total)}</div>
          </div>
        </Col>
      <Col></Col>
    </Row>
  }


  return (
    <>
    <Row className="mt-3">
      <Col>
        <Card>
        <div className="d-flex flex-row">
          <div className="d-flex w-50">
            <div className="d-flex flex-column grupo-input mr-2 w-100">
              <small>Día de calculo</small>
              <DateRangePicker
                format={'DD/MM/YYYY'}
                value={dataOriginal}
                onClean={resetDate}
                onChange={value => {
                  setValueRpOne(value);
                }}
                block
                locale={utils.configCalendar.locale}
              /> 
            </div>
          </div>
          <div className="d-flex w-50">
            <div className="d-flex flex-column grupo-input mr-2 w-100">
              <small>Filtrar por usuario</small>
              <UsuariosSelect
                onSelected={(value) => userselectedfilter(value)}
                reset={null}
              />
            </div>
          </div>
          </div>
          <DataTable
            title="Sucursales"
            customStyles={table.customStyles}
            columns={table.columnSucursales}
            data={sucursales}
            dense={true}
            pagination={true}
            paginationPerPage={5}
            selectableRows={true}
            onSelectedRowsChange={sucursalSelected}
            clearSelectedRows={toggleOne}
            contextMessage={{
              singular: 'Sucursal',
              plural: 'Sucursales',
              message: 'seleccionados',
            }}
          />
          <div className="mt-2 d-flex">
           <button onClick={generarReporteOne} type="button" className="btnx btnx-warn">Generar</button> {' '}
           <button onClick={resetReportOne} type="button" className="btnx btnx-warn">Limpiar</button> {' '}
          </div>
        </Card>
      </Col>
    </Row>

    {dataRpOne && 
    <Row className="mt-3">
      <Col>
        <Card>
           {dataRpOne &&
              dataRpOne.guiasRespuesta.length ?
              <>
              <div className="d-flex justify-content-between mb-2">
                <div className="d-flex flex-column">
                  <div style={{ fontWeight: 'bold' }}>Rango de fechas consultados desde {moment(reporteOne.init).format('DD/MM/YYYY')} hasta {moment(reporteOne.end).format('DD/MM/YYYY')}</div>
                  <div style={{ fontWeight: 'bold' }}>Total de registros: {dataRpOne.guiasRespuesta.length}</div>
                  <div style={{ fontWeight: 'bold' }}>Filtro usuario: { user.username.toUpperCase() }</div>
                </div>
                <div className="d-flex">
                  <div className="d-flex flex-row" style={{ height: 44 }}>
                    <PrinterDiario config={config} data={dataRpOne} suc={reporteOne.sucursales.length}/>
                    <button onClick={parsedataexcelformat} type="button" className="btnx btnx-warn ml-1">Exportar excel</button>
                  </div>
                </div>
              </div>
              {dataRpOne && valuesPayments()}
              </>
              : null
            }
            <div className="mt-2">
              <DataTable
                noHeader={true}
                customStyles={customStyles}
                columns={colummns}
                data={dataRpOne ? dataRpOne.guiasRespuesta : []}
                dense={true}
                pagination={true}
                paginationPerPage={40}
                noDataComponent={'No se encontraron registros'}
              />
            </div>
        </Card>
      </Col>
    </Row>
    }
    </>
  )
}

export default DesgloseReport;